import { render, staticRenderFns } from "./globalsearch.vue?vue&type=template&id=f7ddd438&scoped=true"
import script from "./globalsearch.vue?vue&type=script&lang=js"
export * from "./globalsearch.vue?vue&type=script&lang=js"
import style0 from "./globalsearch.vue?vue&type=style&index=0&id=f7ddd438&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ddd438",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/globalsearch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7ddd438')) {
      api.createRecord('f7ddd438', component.options)
    } else {
      api.reload('f7ddd438', component.options)
    }
    module.hot.accept("./globalsearch.vue?vue&type=template&id=f7ddd438&scoped=true", function () {
      api.rerender('f7ddd438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/globalsearch.vue"
export default component.exports